import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'csi-form-template-radio-field-config',
  templateUrl: './form-template-radio-field-config.component.html',
  styleUrls: ['./form-template-radio-field-config.component.css']
})
export class FormTemplateRadioFieldConfigComponent implements OnInit {
  @Input() templateFieldFormGroup: FormGroup;

  constructor() {}

  ngOnInit() {
    (this.templateFieldFormGroup.controls['typeConfig'] as FormGroup).addControl(
      'valuesConfig',
      new FormGroup({})
    );
  }
}
